import * as React from "react";

import Tooltip from "@mui/material/Tooltip";
import { isJapanese } from "../../../HelperSrc";
import { FloatingLabelProps } from "../../../interface";

const FloatingLabel = (props: FloatingLabelProps): React.ReactElement => {
    const { text, required, tooltip } = props;
    return (
        <div className={`floating_label ${isJapanese(text) ? "japanese" : ""}`}>
            <div className="text_container">
                <span>
                    {text}
                    {required && <div className="require_symbol" />}
                    {tooltip && tooltip.title && <Tooltip {...tooltip}>{tooltip.children || <div className="tooltip_info">i</div>}</Tooltip>}
                </span>
            </div>
        </div>
    );
};

export default FloatingLabel;
